var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import * as PropTypes from "prop-types";
import { withRouter } from "react-router";
import { connect } from "@irati/store";
import Loading from "@irati/ui/src/Loading";
import { injectIntl } from "@irati/utils/lang";
import History from "@irati/utils/history";
import authentication from "@irati/auth";
import { hangPromise } from "@irati/utils/promise";
import PerksSagaService from "@irati/deals/services/perks-saga";
import WalletActions from "@irati/wallet/store/actions/Wallet";
import redemptionUtils from "../../helpers/redemption/redemptionUtils";
var PaymentComplete = /** @class */ (function (_super) {
    __extends(PaymentComplete, _super);
    function PaymentComplete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            load: hangPromise()
        };
        return _this;
    }
    PaymentComplete.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, match = _a.match, getWallet = _a.getWallet;
        var requests = [
            PerksSagaService.get(match.params.sagaUuid)
        ];
        if (authentication.apps("wallet.users")) {
            requests.push(getWallet());
        }
        var load = Promise.all(requests).then(function (_a) {
            var saga = _a[0];
            var deal = saga.redemption.deal;
            deal.urlSlug = match.params.urlSlug;
            return redemptionUtils.complete(saga).then(function (updatedSaga) {
                var nextStep = redemptionUtils.currentStep(updatedSaga, deal);
                History.replace({
                    pathname: nextStep,
                    state: {
                        deal: deal,
                        saga: updatedSaga
                    }
                }, _this.context);
            }).catch(function () {
                // @TODO: Change this to handle errors in line
                // ^^ Cannot do this yet as saga service will unreserve stock on failure.
                History.replace({
                    pathname: "/info/" + deal.urlSlug + "/pay/" + saga.uuid + "/error",
                    state: { deal: deal }
                }, _this.context);
            });
        });
        this.setState({ load: load });
    };
    PaymentComplete.prototype.render = function () {
        var load = this.state.load;
        return (React.createElement(Loading, { load: load }));
    };
    PaymentComplete.contextTypes = {
        appPath: PropTypes.string.isRequired
    };
    return PaymentComplete;
}(PureComponent));
var mapDispatchToProps = function (dispatch) {
    return {
        getWallet: function () { return dispatch(WalletActions.get()); }
    };
};
export default withRouter(injectIntl(connect(null, mapDispatchToProps)(PaymentComplete)));
